<main class="w-100">
    <div class="plate-container w-100 h-100 position-relative">
        <img src="../../../assets/imgs/plate.jpg" alt="پلاک خودرو" loading="lazy">
        <div class=" first-section row gx-0 gy-0">
            <div class="col-5">
                <p class="third-alphabet mb-0"> {{ text3 | faNum }} </p>
            </div>
            <div class="col-3">
                <p class="second-alphabet mb-0 px-1"> {{ text2 }} </p>
            </div>
            <div class="col-4">
                <p class="third-alphabet mb-0"> {{ text1 | faNum }} </p>
            </div>
        </div>
        <div class="second-section row gx-0 gy-0">
            <div class="col-12 ">
                <p class="forth-alphabet mb-0"> {{ text4 | faNum }} </p>
            </div>
        </div>
    </div>
</main>